/**
 * Okta application IDs for apps that Account surfaces.
 *
 * These values must stay in sync with the Okta app registrations for
 * Orion, AirView and ResMed Online Store, and they correspond to
 * ModelsUserApplicationV1.id. When adding or changing IDs, please
 * update this file and any related runbooks or internal documentation.
 */
const ORION_APP_IDS = new Set(['0oa28qw6mzrLRCyil0h8', '0oa2dsllly5yETC7B0h8', '0oaj2fvzjn0waPBJO1d7', '0oav2j56yi3jkQmbA297']);
const AIRVIEW_APP_IDS = new Set([
    '0oaslgk0ofNsy63cO0h7',
    '0oa2jhqzxfnQlQhEe0h8',
    '0oak4s46e7OculB1k1d6',
    '0oa7ca7b9yNqH8sBI297',
    '0oa118hnr0BrmOEiA417',
    '0oa515oq3kFVOcgIa0x7',
    '0oa1psnt2ctLlvbkG0x7',
    '0oatxwa6i1RMZmwI20h7'
]);
const RESMED_ONLINE_STORE_APP_IDS = new Set([
    '0oac9jrijd4VBFFGf0x7',
    '0oac9jsi39nOu1nEG0x7',
    '0oac9jsi36dq0voGs0x7',
    '0oacdvcomrqQGh6e70x7',
    '0oasjzecxh5j3rjBt417'
]);
export const isOrionAppId = (id) => ORION_APP_IDS.has(id);
export const isAirViewAppId = (id) => AIRVIEW_APP_IDS.has(id);
export const isResmedOnlineStoreAppId = (id) => RESMED_ONLINE_STORE_APP_IDS.has(id);
